export const normalizeTimestamp = (value) => value?.toMillis?.() || Date.parse(value || '') || 0;
export const displayName = (profile = {}) => profile?.username || profile?.displayName || profile?.email?.split('@')[0] || 'Member';
export const roomIdForGenre = (genre = 'Books') => genre.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
export const conversationKey = (a, b) => [a, b].sort().join('_');
export const normalizeTitle = (title = '') => title.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
export const workIdFromBook = (book = {}) => book.workId || String(book.openLibraryId || '').replace(/^\/works\//, '').trim() || book.id;
export const formatTime = (value) => {
  const millis = normalizeTimestamp(value);
  if (!millis) return '';
  return new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }).format(millis);
};
